// extracted by mini-css-extract-plugin
export default {"list":"G3a5b23","listItem":"Gcd5e88","textBold":"Gd9603e"};